import type { DocumentModel } from '@/models/document.model';
import { CrudService } from '@/services/crud.service';

export class PricatService {
  private readonly crudService: CrudService<DocumentModel>;

  constructor() {
    this.crudService = new CrudService<DocumentModel>('pricat');
  }

  public async downloadPricat(accountId: string, seasonName: string) {
    const queryParams = new URLSearchParams();
    queryParams.set('accountId', accountId);
    queryParams.set('seasonName', seasonName);

    return this.crudService.downloadFile(
      `download-pricat?${queryParams}`,
      null,
      `pricat-${accountId}-${seasonName}.xlsx`,
      { method: 'GET' },
    );
  }
}
